import { useState, useEffect, type FC } from 'react';

const NAV_ITEMS = [
  { href: '#ranking', label: '热门榜单' },
  { href: '#cards', label: '精选推荐' },
  { href: '#media', label: '视频专区' },
  { href: '#carousel', label: '焦点专题' },
  { href: '#features', label: '平台优势' },
  { href: '#faq', label: '常见问题' },
];

const Header: FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 h-[72px] flex items-center justify-between">
        <a
          href="#hero"
          className="flex items-center gap-2 no-underline group"
        >
          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
            <i className="ri-flower-line text-lg text-white"></i>
          </div>
          <span className="text-xl font-bold text-foreground-950 font-heading tracking-wide group-hover:text-primary-600 transition-colors">
            91樱花
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          <a
            href="#hero"
            className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-md transition-colors whitespace-nowrap"
          >
            首页
          </a>
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-md transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <nav className="md:hidden bg-background-50 border-b border-background-200/60 px-4 pb-4 pt-2 flex flex-col gap-1">
          <a
            href="#hero"
            onClick={() => setMobileOpen(false)}
            className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-md transition-colors"
          >
            首页
          </a>
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMobileOpen(false)}
              className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-md transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Header;